<template>
  <!-- book.is_expired:true、かつ、有効期限が最も後のsheetが期限切れの場合にグレーアウト -->
  <div
    v-if="isReadyToDraw"
    :class="{
      expired: isPastStamp,
    }"
  >
    <!-- ブック -->
    <div class="list-item-book" @click="goToBook(bookGroup)">
      <!-- サムネイル -->
      <MbIndexThumbnailDisp :image-url="masterBook.content.ticket_image_url" />
      <!-- サムネイル -->

      <div class="index-content-center">
        <!-- チケット名 -->
        <MbIndexNameDisp :name="displayBookName(bookGroup, masterBook)" />
        <!-- チケット名 -->
      </div>
    </div>
    <!-- ブック -->

    <div class="list-item__ticket">
      <div class="index-ticket-left">
        <span class="list-item__title passsheet_title">
          {{ $t("MyTicketTicketing.StampRally.title") }}
        </span>
      </div>

      <SRUseStatusButton
        :book-group="bookGroup"
        :is-past-stamp="isPastStamp"
        :is-not-target-version="isNotTargetVersion"
      />

      <div class="ticket-index-square left-square"></div>
      <div class="ticket-index-square right-square"></div>
    </div>

    <ItemIndexBookUsed v-if="isLocal" :book="book" />
  </div>
</template>

<script>
import { computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "ItemIndexBookStampRally",
  props: {
    bookGroup: {
      type: Object,
      required: true,
    },
    isNotTargetVersion: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const isReadyToDraw = ref(false);
    const book = computed(() => props.bookGroup.books[0]);
    const masterBook = computed(() => props.bookGroup._master_book);

    const isLocal = process.env.NODE_ENV == "local" ? true : false;

    const isPastStamp = computed(() => route.path.includes("past-tickets"));

    watchEffect(() => {
      if (book.value != null && masterBook.value != null) {
        isReadyToDraw.value = true;
      }
    });

    // ↓↓↓↓リンク処理↓↓↓↓
    const goToBook = (selectedBookGroup) => {
      console.log("ENV :>> ", process.env.NODE_ENV);
      if (process.env.NODE_ENV == "local") {
        router.push({
          name: "Book",
          params: { book_group_id: selectedBookGroup.id },
          query: { language: store.getters["common/lang"] },
        });
      } else {
        nativeHandlerService.openTicket(
          `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}my-tickets/ticketing/${selectedBookGroup.id}`
        );
      }
    };
    // ↑↑↑↑リンク処理↑↑↑↑

    return {
      book,
      masterBook,
      isReadyToDraw,
      goToBook,
      isLocal,
      isPastStamp,
    };
  },
};
</script>

<style scoped lang="scss">
.expired {
  background: #f0f0f0;
}

.index {
  position: relative;
}

.list-item-book {
  height: 85px;
  max-height: 23vw;
}

.index-content-center {
  overflow: hidden;
  width: 73%;
  position: relative;
  height: 100%;
  padding-left: 2%;
  float: left;
}

.index-content-right {
  position: relative;
  top: 30%;
}

.list-item__passenger {
  font-size: 2vw;
  position: absolute;
  top: 80%;
  color: #777777;
  font-weight: bold;
  width: 100%;
}

.list-item__header {
  font-size: 3vw;
  width: 20%;
  display: inline-block;
}

.list-item-value {
  font-size: 3vw;
  font-weight: bold;
}

.list-item__ticket {
  height: 51px;
  position: relative;
  border-top: 1px dashed #d7d7d7;
}

.list-item__ticket .used {
  height: 12vw;
  border-top: 1px dashed #f9f9f9;
}

.list-item__title {
  font-size: 15px;
  position: absolute;
  top: 25%;
  overflow: hidden;
  font-weight: bold;
}

.index-ticket-left {
  float: left;
  width: 77%;
  font-size: 3vw;
  overflow: hidden;
  padding: 0 2%;
  position: relative;
  top: 50%;
  transform: translate(0%, -50%);
  -webkit-transform: translate(0%, -50%);
  -ms-transform: translate(0%, -50%);
}

.passsheet_title {
  position: unset;
  display: block;
  margin: 4vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 500;
}

.ticket-index-square {
  position: relative;
  width: 16px;
  height: 16px;
  background-color: #f9f9f9;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  z-index: 0;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
}

.left-square {
  margin-left: -5.5px;
  top: -10px;
  border-bottom: none;
  border-left: none;
}

.right-square {
  margin-left: calc(100% - 12px);
  top: -26px;
  border-top: none;
  border-right: none;
}

@media screen and (min-width: 421px) {
  /* ブラウザ対応 */
  .list-item-book {
    height: 20vw;
  }

  .list-item__passenger {
    top: 75%;
  }

  .list-item__ticket {
    height: 12vw;
  }

  .list-item__title {
    font-size: 4vw;
  }
}
</style>
